import { fromSearchToState } from '../utils/router';

//-------------------------------------------------------------------------------------------actions
const LOCATION_CHANGED = '@@router/LOCATION_CHANGED';

//------------------------------------------------------------------------------------------creators
// react-router owns the location; this mirrors it into the store, which is what
// the ~25 router selectors read.
//
// On POP the query string is the only source that can be trusted: the entry the
// browser restores may carry no state at all -- an url that was shared, shortened
// or typed -- so the location state is rebuilt from the search.
export const locationChanged = (location, navigationType) => ({
  type: LOCATION_CHANGED,
  payload: {
    location:
      navigationType === 'POP'
        ? { ...location, state: fromSearchToState(location.search) }
        : location,
    action: navigationType,
  },
});

//-------------------------------------------------------------------------------------------reducer
// Seeded from the history so the selectors answer correctly on the very first
// render, before any navigation has happened.
export const createRouterReducer = history => {
  const model = () => ({ location: history.location, action: history.action });
  return (state = model(), action = {}) =>
    action.type === LOCATION_CHANGED ? action.payload : state;
};
